<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Bordados</h3>
          <p>
            Configuración de las iniciales y sus características (tamaños,
            precios, fuente y alturas).
          </p>

          <!-- <h4>Características básicas</h4> -->
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.success.show" variant="success">{{
              form.success.text
            }}</b-alert>
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <!-- <h4>Características</h4> -->

            <b-form-row class="mt-4">
              <b-col>
                <h4>Tamaños y precios</h4>

                <b-button size="sm" variant="outline-primary" @click="addSize"
                  >Nuevo tamaño</b-button
                >

                <b-form-row class="mt-4">
                  <b-col :cols="2"><label>Tamaño</label> </b-col>
                  <b-col :cols="2"><label>Altura</label> </b-col>
                  <b-col :cols="2"><label>Precio monocolor</label> </b-col>
                  <b-col :cols="2"><label>Precio multicolor</label> </b-col>
                </b-form-row>
                <b-form-row
                  v-for="(v, i) in $v.form.sizes.$each.$iter"
                  :key="i"
                >
                  <b-col :cols="2"
                    ><b-form-group id="input-group-name" label-for="input-name">
                      <b-form-input
                        v-model="v.name.$model"
                        :state="validateStateSize(i, 'name')"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="2"
                    ><b-form-group
                      id="input-group-height"
                      label-for="input-height"
                    >
                      <b-input-group append="cm">
                        <b-form-input
                          id="height"
                          :value="v.height.$model.replace('.', ',')"
                          @change="setDecimalSize(i, 'height', $event)"
                          :state="validateStateSize(i, 'height')"
                          aria-describedby="input-height-feedback"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-price_unicolor"
                      label-for="input-price_unicolor"
                    >
                      <b-input-group append="€">
                        <b-form-input
                          id="price_unicolor"
                          :value="v.price_unicolor.$model.replace('.', ',')"
                          @change="setDecimalSize(i, 'price_unicolor', $event)"
                          :state="validateStateSize(i, 'price_unicolor')"
                          aria-describedby="input-price_unicolor-feedback"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col :cols="2">
                    <b-form-group
                      id="input-group-price_multicolor"
                      label-for="input-price_multicolor"
                    >
                      <b-input-group append="€">
                        <b-form-input
                          id="price_multicolor"
                          :value="v.price_multicolor.$model.replace('.', ',')"
                          @change="
                            setDecimalSize(i, 'price_multicolor', $event)
                          "
                          :state="validateStateSize(i, 'price_multicolor')"
                          aria-describedby="input-price_multicolor-feedback"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="auto"
                    ><b-button
                      :disabled="form.sizes.length === 1"
                      @click="removeSize(i)"
                      variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-button class="mt-4" type="submit" variant="primary"
              >Guardar cambios</b-button
            >

            <b-row class="mt-5">
              <b-col cols="12">
                <!-- <h4>Listado</h4> -->
                Viendo:
                <b-button-group>
                  <b-button
                    size="sm"
                    @click="showingEmbroideries = 'standard'"
                    :pressed="showingEmbroideries == 'standard'"
                    >Estándar</b-button
                  >
                  <b-button
                    size="sm"
                    @click="showingEmbroideries = 'customized'"
                    :pressed="showingEmbroideries == 'customized'"
                    >Personalizados</b-button
                  >
                </b-button-group>
              </b-col>
            </b-row>

            <b-form-row class="mt-4">
              <b-col cols="12">
                <h4>
                  {{
                    showingEmbroideries == 'customized'
                      ? 'Bordados personalizados'
                      : 'Bordados estándar'
                  }}
                </h4>

                <StandardEmbroideryList
                  v-if="showingEmbroideries == 'standard'"
                ></StandardEmbroideryList>

                <b-row v-if="showingEmbroideries == 'customized'">
                  <b-col cols="12"
                    ><b-form-row class="mt-4">
                      <b-col :cols="2"><label>Tamaño</label> </b-col>
                      <b-col :cols="2"><label>Precio picaje</label> </b-col>
                    </b-form-row>
                    <b-form-row
                      v-for="(v, i) in $v.form.sizes.$each.$iter"
                      :key="i"
                    >
                      <b-col :cols="2"
                        ><b-form-group
                          id="input-group-name"
                          label-for="input-name"
                        >
                          <b-form-input
                            v-model="v.name.$model"
                            :disabled="true"
                            :state="validateStateSize(i, 'name')"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col :cols="2">
                        <b-form-group
                          id="input-group-price_pecking"
                          label-for="input-price_pecking"
                        >
                          <b-input-group append="€">
                            <b-form-input
                              id="price_pecking"
                              :value="v.price_pecking.$model.replace('.', ',')"
                              @change="
                                setDecimalSize(i, 'price_pecking', $event)
                              "
                              :state="validateStateSize(i, 'price_pecking')"
                              aria-describedby="input-price_pecking-feedback"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col> </b-form-row
                  ></b-col>
                  <b-button class="mt-4" type="submit" variant="primary"
                    >Guardar cambios</b-button
                  >
                </b-row>
              </b-col>
            </b-form-row>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import StandardEmbroideryList from '@/admin/components/embroideries/StandardEmbroideryList.vue';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminEmbroiderySettingsScreen',
  props: {},
  components: {
    Multiselect,
    VueCropper,
    StandardEmbroideryList,
  },
  mixins: [validationMixin],
  validations() {
    let rules = {
      sizes: {
        $each: {
          name: {
            required,
          },
          height: {
            required,
            decimal,
            minValue: minValue(0.0),
          },
          price_unicolor: {
            required,
            decimal,
            minValue: minValue(0.0),
          },
          price_multicolor: {
            required,
            decimal,
            minValue: minValue(0.0),
          },
          price_pecking: {
            required,
            decimal,
            minValue: minValue(0.0),
          },
        },
      },

      typographies: {
        $each: {
          name: {
            required,
          },
          typography: {
            required,
          },
          sizes: {
            $each: {
              enabled: {
                required,
              },
              height: {
                required,
                decimal,
                minValue: minValue(0.0),
              },
            },
          },
        },
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      sizes: [],
      typographies: [],

      error: {
        show: false,
        text: '',
      },
      success: {
        show: false,
        text: '',
      },
      optionsTypographies: [],
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
      showingEmbroideries: 'standard',
    };
  },
  created() {
    actions.getEmbroiderySettings().then((x) => {
      if (x.data.count === 0) {
        store.setOverlayShow(false);

        this.addSize();
      } else {
        const data = x.data.results[0];

        this.form.sizes = data.sizes;
        this.form.typographies = data.typographies;
      }

      store.setOverlayShow(false);
    });
  },
  methods: {
    addSize() {
      this.form.sizes.push({
        name: '',
        height: '',
        price_unicolor: '0.0',
        price_multicolor: '0.0',
        price_pecking: '0.0',
      });
    },

    removeSize(i) {
      this.form.sizes.splice(i, 1);
      this.form.typographies.map((typography) => {
        typography.sizes.splice(i, 1);
      });
    },

    setDecimalSize(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.sizes.$each.$iter[index][name].$model = val;
      this.$v.form.sizes.$each.$iter[index][name].$touch();
    },

    setDecimalTypographySize(indexTypography, indexSize, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.typographies.$each.$iter[indexTypography].sizes.$each.$iter[
        indexSize
      ][name].$model = val;
      this.$v.form.typographies.$each.$iter[indexTypography].sizes.$each.$iter[
        indexSize
      ][name].$touch();
    },

    validateStateSize(index, name) {
      const { $dirty, $error } = this.$v.form.sizes.$each.$iter[index][name];
      return $dirty ? !$error : null;
    },
    validateStateTypography(index, name) {
      const { $dirty, $error } = this.$v.form.typographies.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },
    validateStateTypographySize(indexTypography, indexSize, name) {
      const { $dirty, $error } = this.$v.form.typographies.$each.$iter[
        indexTypography
      ].sizes.$each.$iter[indexSize][name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.$v.$reset();

      store.setOverlayShow(true);

      let data = {};

      data.sizes = this.form.sizes;
      data.typographies = this.form.typographies;

      Sentry.setExtra('data', JSON.stringify(data));

      actions
        .postEmbroiderySetting(data)
        .then((x) => {
          store.setOverlayShow(false);

          this.form.success = {
            show: true,
            text: 'Información guardada satisfactoriamente',
          };
        })
        .catch((y) => {
          store.setOverlayShow(false);

          this.form.error = {
            show: true,
            text: 'Ha ocurrido un error inesperado',
          };
          console.error(y);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
